<!-- Display Cards -->
<ng-container *ngIf="!inline">
	<div
		[routerLink]="['/session', formationThematique.getId(), 'details']"
		class="clicable p-relative"
	>
		<div class="cards-container formation-cards-container">
			<!-- Cards -->
			<div class="circle-cards">
				<div
					class="content-circle"
					[style.border-color]="color.props.main"
					[style.border-width.px]="2"
				>
					<span class="day-card" [style.color]="color.props.main">{{
						formationThematique.props.start_date
							| date: 'dd':'':translateService.currentLang
					}}</span>
					<span class="month-card">{{
						formationThematique.props.start_date
							| date: 'MMMM':'':translateService.currentLang
					}}</span>
					<span class="year-card">{{
						formationThematique.props.start_date
							| date: 'yyyy':'':translateService.currentLang
					}}</span>
				</div>
				<div class="content-avatar">
					<nz-avatar
						class="respondant-avatar"
						[ngClass]="avatar ? 'avatarPhoto' : 'avatarIcone'"
						[nzSize]="60"
						nzIcon="user"
						[nzSrc]="avatar"
					></nz-avatar>
				</div>
			</div>

			<!-- /Cards -->
		</div>
		<div class="name-wrapper">
			<span class="name-card">
				{{ formationThematique.props.name }}
			</span>
		</div>
	</div>
</ng-container>
<!-- / Display Cards -->

<!-- Display Inline -->
<ng-container *ngIf="inline">
	<a
		class="row d-flex flex-nowrap justify-content-start align-items-center px-0 py-3 m-0 mx-md-4 inline-wrapper"
		[routerLink]="['/session', formationThematique.getId(), 'details']"
	>
		<span class="col-5 col-xl-5 sponsor d-md-flex align-items-center">
			<nz-avatar
				class="respondant-avatar"
				[ngClass]="avatar ? 'avatarPhoto' : 'avatarIcone'"
				[nzSize]="60"
				nzIcon="user"
				[nzSrc]="avatar"
			></nz-avatar>

			{{ sponsor }}
		</span>
		<span
			class="col-2 col-sm-3 col-xl-5 module d-md-flex align-items-center"
		>
			{{ formationThematique.props.name }}
		</span>
		<span class="col-3 col-sm-2 date">
			{{ formationThematique.props.start_date | date: 'dd/MM/yy' }}
		</span>
	</a>
</ng-container>
<!-- / Display Inline -->
